/*
 * Copyright (c) 2021-2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: BpReadonlyWrapper.tsx
 * Project: mle-client
 * Committed last: 2021/10/14 @ 1517
 * ---
 */

import { FormGroup, IconName, InputGroup } from '@blueprintjs/core';
import React                               from 'react';

export const BpReadonlyWrapper = (props: { value: string, label: string, labelInfo?: string, icon?: IconName }) => (
  <FormGroup
    label={ props.label }
    labelInfo={ props.labelInfo }
  >
    <InputGroup disabled readOnly leftIcon={ props.icon }
                value={ props.value }/>
  </FormGroup>
);
